import { Services } from '@sigma-frontend-libs/commons'

import preloader from '@/components/preloader'
import overflow from '@/components/text/overflow'

const className = `${Services['report-manager']}-filterBy-tag`

function renderAbsolutePreloader(h) {
  if (this.value.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [
        h(
          preloader,
          {
            props: {
              size: 8
            }
          }
        )
      ]
    )
  }
}
function renderLabel(h) {
  return h(
    'div',
    {
      class: `${className}__label`
    },
    [ this.value.label ]
  )
}
function renderValue(h) {
  return h(
    'div',
    {
      class: `${className}__value`
    },
    [
      h(
        overflow,
        {
          props: {
            value: this.value.value
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: className
    },
    [
      renderLabel.call(this, h),
      renderValue.call(this, h),
      renderAbsolutePreloader.call(this, h)
    ]
  )
}
